import { addActionToUndoStack, clearLastUndoableAction, hasUndoableAction, } from './actions/undoActions';
import { LazyAction, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "UndoAction" */ './lazyIndex');
});
export var lazyUndo = new LazyAction(lazyModule, function (m) { return m.undo; });
export { addActionToUndoStack, clearLastUndoableAction, hasUndoableAction };
//# sourceMappingURL=index.js.map